import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router";
import styles from "./SignIn.module.css";
import { useAuth } from "../../context/AuthContext";
import { Toast } from 'primereact/toast';

import Loading from './../Loading/Loading';


export const SignIn = () => {
  const { login,  currentUser, myUser } = useAuth();
  const [dataForm, setDataForm] = useState({});
  const [error, setError] = useState('');
  const history = useHistory('/');
  const toast = useRef();
  let [loading, setLoading] = useState(false);


  const showErrorLogin = () => {
    toast.current.show({ severity: 'error', summary: 'Error de Ingreso', detail: 'Datos incorrectos', life: 3000 });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://kit.fontawesome.com/64d58efce2.js";
    script.async = true;
    document.body.appendChild(script);
  }, [])

  const handleRegiter = (e) => {
    history.replace('/register');
  };

  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      //console.log (`Datos: ${dataForm.emailLog} ${dataForm.passwordLog}`);
      await login(dataForm.emailLog, dataForm.passwordLog);
      //console.log (`Antes:  ${myUser.user.uid}`);
      // console.log(`Login:  ${JSON.stringify(myUser, null, 4)}`);
      // console.log(`History:  ${myUser} ${currentUser.uid}`);
      if (myUser && currentUser) {
        // const docRef = doc(db_firestore, "users", myUser.user.uid);
        // const docSnap = await getDoc(docRef);
        // if (docSnap.exists()) {
        //console.log("Document data:", myUser.data());
        //console.log(`History:  ${myUser.name} `);
       // history.push('/');
        //}
      }
      history.replace('/'); //Usando replace NO dejo huella en el Hisroty de la ruta actual
      setLoading(false);
    }
    catch (err) {
      setLoading(false);
      showErrorLogin();
      setError('Error de Login!');
      setTimeout(() => {
        setError('')
      }, 1500);
      setLoading(false);
    }
  };


  // const handleDebug = (e) => {
  //   e.preventDefault();
  //   console.log(`History:  ${myUser.name} ${currentUser.uid}`);
  //   history.push('/');
  //   //}

  // }




  const handleChange = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
  };



  return (
    <div> {loading && <Loading />}
      <div className={`${styles.body} ${styles.container}`} id="container">
        <Toast ref={toast} />
        <div className={styles.formsContainer}>
          <div className={styles.signinSignup}>
            <form onSubmit={handleLogin}>
              <img src="assets/images/plasti.png" className={styles.imagePlasti} alt="" />
              <p />
              <p className={styles.title} style={{ fontSize: '35px' }} > <b>Ingresar</b></p>
              <div className={styles.inputField}>
                <i className="fas fa-user"></i>
                <input type="text" placeholder="Email" name="emailLog" onChange={handleChange} />
              </div>
              <div className={styles.inputField}>
                <i className="fas fa-lock"></i>
                <input type="password" placeholder="Contraseña" name="passwordLog" onChange={handleChange} />
              </div>
              <input value="INGRESAR" className={`${styles.btn}`} type="submit" />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </form>
          </div>
          <div className={styles.containerBottom}>

          </div>
        </div>

        <div className={styles.panelsContainer}>
          <div className={`${styles.panel} ${styles.leftPanel}`}>
            <div className={styles.content}>
              <div className={styles.fontSizeH3}>La primera vez ?</div>
              <p className={styles.nota}>Bienvenido, para registrarse pulse el siguiente boton!</p>
              <button className={`${styles.btn} ${styles.transparent} ${styles.fontSizeBoton}`} id="sign-up-btn" onClick={handleRegiter} >
                Registrarse
                </button>
            </div>
            <img src="assets/images/login.svg" className={styles.image} alt="" />
          </div>
        </div>
      </div >
    </div>
  )
}


